// extracted by mini-css-extract-plugin
export default {"flagIcon":"lVgxp","fieldClassName":"eI1JD","errorClassName":"ZOFK6","removeTariff":"YNnZv","firstLine":"iKqX7","secondLine":"PNmmu","shippingCount":"YY9s8"};